import React, {createContext} from 'react';
import ReactDOM from 'react-dom';
import './css/bootstrap.min.css';
import './css/asiera-theme.css';
import './css/extra.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

document.title = 'Asiera PDU Management';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
